import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import AssistanceAgreementForm from './AssistanceAgreementForm';
import Loader from '../Loader';
import { starSetAssistanceAgreement, starGetAssistanceAgreement, getAssistanceAgreement , setAssistanceAgreement } from '../../actions/assistanceAgreement';
import { pushToDataLayer } from '../../utils/gtmUtils';

export class AssistanceAgreementPage extends React.Component {

    componentWillMount() {
        const self = this;
        this.props.starGetAssistanceAgreement(this.props.beneficiaryData.idBeneficiaire, this.props.partenaireData.id).then((response) => {
            self.setState({ data: response.data });
            this.props.getAssistanceAgreement(response.data);
        });
    }


    onSubmit = (assistanceAgreementData) => {
        const dataLayer = {
            event: "assistanceAgreementSave",
            url: window.location.href,
            idPartenaire: this.props.partenaireData.id
        }
        pushToDataLayer(dataLayer);
        assistanceAgreementData.idBeneficiaire = this.props.beneficiaryData.idBeneficiaire;
        const serverData =  {
            idBeneficiaire : this.props.beneficiaryData.idBeneficiaire,
            autorisationStockageDonnees: assistanceAgreementData.autorisationStockageDonnees
        }
        this.props.starSetAssistanceAgreement(serverData, this.props.partenaireData.id).then(response => {
            this.props.setAssistanceAgreement(assistanceAgreementData)
            this.props.history.push('/accueil');
        }).catch(function (error) {
            console.log('erorr', error);
        })
    };
    
    onAnnuler = () => {
    	this.props.history.push('/accueil');
    }
    render() {
        return (
            <div className="assistance-agreement-page container main-container">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/" >Accueil</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">Ma convention d'assistance</li>
                </ol>
                <h1 className="text-center">Ma convention d'assistance</h1>
                <div className="intro-text">
                    Avant de commencer à saisir vos volontés, vos devez autoriser {this.props.partenaireData.marqueAllianzPartners} à conserver vos données, à les
                    restituer à votre chargé de mémoire et à mettre en oeuvre les prestations d'assistance annoncées dans la 
                    convention. L'organisation et la mise en oeuvre des prestations d'assistance sont confiées à AWP France SAS.
                </div>
                {this.state && this.state.data ?
                    <AssistanceAgreementForm
                        onSubmit={this.onSubmit}
                        data={this.state.data}
                		annuler={this.onAnnuler}
                    />
                    :
                    <Loader />
                }
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    starSetAssistanceAgreement: (assistanceAgreementData, partnerId) => dispatch(starSetAssistanceAgreement(assistanceAgreementData, partnerId)),
    starGetAssistanceAgreement: (benefId, partnerId) => dispatch(starGetAssistanceAgreement(benefId, partnerId)),
    getAssistanceAgreement: (data) => dispatch(getAssistanceAgreement(data)),
    setAssistanceAgreement : (data) => dispatch(setAssistanceAgreement(data))
});

const mapStateToProps = state => ({
    assistanceAgreementData: state.assistanceAgreementData,
    beneficiaryData: state.beneficiaryData.idBeneficiaire ? state.beneficiaryData :  JSON.parse(sessionStorage.getItem('benef')),
    partenaireData: state.partenaireData
})

export default connect(mapStateToProps, mapDispatchToProps)(AssistanceAgreementPage);




// WEBPACK FOOTER //
// ./src/components/AssistanceAgreementPage/AssistanceAgreementPage.js